/**
 * pcn-qty-rules.js — Red de seguridad para reglas de cantidad por producto.
 *
 * La regla vive en el metaobjeto product.metafields.custom.product_rule
 * (minimum / maximum / increment). Los snippets cart-item y cart-item-page
 * pintan min/max en el input de cada línea del carrito y los botones +/- del
 * theme respetan `max`. Pero el handler de "change" del theme NO clampa: si el
 * cliente tipea un número a mano, vuelve a agregar desde la página del
 * producto, usa quick-add o la barra sticky, la línea queda por encima del
 * máximo.
 *
 * Este script, tras cualquier render del carrito (mini cart o página):
 * si una línea supera su max, la baja al max, avisa al cliente y dispara el
 * flujo normal del theme (evento change -> /cart/change.js -> re-render).
 * En productos sin regla no actúa (max del theme = inventario o 9999).
 */
(function () {
  'use strict';

  if (window.__pcnQtyRules) return;
  window.__pcnQtyRules = true;

  var MENSAJE = 'Solo se puede llevar [max] unidad(es) de este producto por pedido.';
  var timer = null;
  var enCurso = false;

  // El theme muestra su propio aviso de maximo con T4Sstrings.notice_stock_msg
  // (products.product.notice_only_stock). Si la traduccion esta vacia, el toast
  // sale mudo en todo el sitio. Lo rellenamos ANTES de que Unsen inicialice sus
  // controles de cantidad (captura la frase al arrancar). Si la traduccion
  // existe, no la tocamos.
  function asegurarFraseDelTheme() {
    try {
      var s = window.T4Sstrings;
      if (s && (typeof s.notice_stock_msg !== 'string' || !s.notice_stock_msg.replace(/\s/g, ''))) {
        s.notice_stock_msg = MENSAJE;
      }
    } catch (e) { /* sin T4Sstrings: nada que rellenar */ }
  }
  asegurarFraseDelTheme();

  function avisar(max) {
    // Misma frase que usa el theme para su propio aviso de maximo
    // (products.product.notice_only_stock, con [max]); si esta vacia, la nuestra.
    var plantilla = MENSAJE;
    try {
      var delTheme = window.T4Sstrings && window.T4Sstrings.notice_stock_msg;
      if (typeof delTheme === 'string' && delTheme.replace(/\s/g, '')) plantilla = delTheme;
    } catch (e) { /* sin strings del theme: usamos la nuestra */ }
    var msg = plantilla.replace('[max]', max);
    try {
      if (window.T4SThemeSP && typeof window.T4SThemeSP.Notices === 'function') {
        window.T4SThemeSP.Notices(msg);
      }
    } catch (e) { /* el aviso es cosmético: nunca romper el clamp por esto */ }
  }

  function revisar() {
    if (enCurso) return;
    var inputs = document.querySelectorAll('input[data-action-change][data-quantity-value][max]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var max = parseInt(input.getAttribute('max'), 10);
      var val = parseInt(input.value, 10);
      if (!max || isNaN(val) || val <= max) continue;

      // Una línea por pasada: el re-render del theme vuelve a disparar revisar()
      enCurso = true;
      input.value = max;
      avisar(max);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(function () { enCurso = false; }, 1500);
      return;
    }
  }

  function programar() {
    clearTimeout(timer);
    timer = setTimeout(revisar, 200);
  }

  function iniciar() {
    revisar();
    // Mini cart y página de carrito se re-renderizan por AJAX (section rendering)
    new MutationObserver(programar).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
